const State = {
    lots:[],
    defaultClient:null,
    txUrl:null,
}

export default State;